<!--
 * @Author: fusanqiasng
 * @Date: 2022-09-28 14:12:31
 * @LastEditors: fusanqiasng
 * @LastEditTime: 2022-11-01 18:19:53
 * @Description: 推荐页
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <xm-page class="recommend-page">
    <xm-scroll v-if="hotSellList.length > 0" :on-refresh="onRefresh" :on-infinite="onInfinite" :enableInfinite="hasMore">
      <ul class="product">
        <li v-for="(item, index) in hotSellList" :key="index" @click="toProDetail(item.id)">
          <div class="avatar">
            <img :src="item.coverResource.resUrl || goodsDefaultImg[item.category]" alt />
            <span v-if="item.coverCornerMark" :class="`corner-mark ${!MARKS.includes(item.coverCornerMark) ? 'customer' : item.coverCornerMark}`">
              {{ !MARKS.includes(item.coverCornerMark) ? item.coverCornerMark : '' }}
            </span>
          </div>
          <div class="desc">
            <div class="name">{{ item.commodityAlias }}</div>
            <div>
              <div class="tag">
                <span class="item" v-if="item.category === 'COURSE'">课程</span>
                <span class="item" v-if="item.category === 'GOODS'">物品</span>
                <span class="item" v-if="item.category === 'FEE_ITEM'">费用</span>
                <span class="item" v-if="item.category === 'SUITE'">套餐</span>
              </div>
              <div class="footer">
                <div class="price-con" v-if="item.category === 'COURSE'">
                  <span class="origin-price">
                    ¥ {{ sortCoursePrice(item.coursePrices) }}
                    <span v-if="item.coursePrices.length > 1"> <span class="text">起</span></span>
                  </span>
                  <span
                    v-if="
                      sortUnderlinePrice(item.coursePrices) &&
                        sortUnderlinePrice(item.coursePrices) !== 0 &&
                        sortUnderlinePrice(item.coursePrices) !== sortCoursePrice(item.coursePrices)
                    "
                  >
                    <span class="line-price"> ¥{{ sortUnderlinePrice(item.coursePrices) }}</span
                    ><span class="line-price" v-if="item.coursePrices.length > 1">起</span>
                  </span>
                </div>
                <div class="price-con" v-if="item.category === 'SUITE'">
                  <span class="origin-price">¥ {{ item.commodityPrice }}</span>
                  <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                    ¥{{ item.underlinePrice }}
                  </span>
                </div>
                <div class="price-con" v-if="item.category === 'GOODS' || item.category === 'FEE_ITEM'">
                  <span class="origin-price">¥ {{ item.commodityPrice }}</span>
                  <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                    ¥{{ item.underlinePrice }}
                  </span>
                </div>
                <div>
                  <xm-button class="buy-btn">立即购买</xm-button>
                </div>
              </div>
            </div>
          </div>
        </li>
        <div class="bottom-tip">已经到底了～</div>
      </ul>
    </xm-scroll>
    <div v-else class="down-con df-c" style="height: 100%;">
      <div>
        <img src="https://image.xiaomaiketang.com/xm/ZCwzpFzsiX.png" class="down-img" />
        <div class="tip">暂无推荐商品~</div>
      </div>
    </div>
  </xm-page>
</template>

<script>
import User from '@/core/user';
import WechatApi from '@/core/wechatApi';
export default {
  components: {},
  mounted() {
    this.doShare()
    this.fetchHotSellCommodityList();
  },
  data() {
    return {
      hotSellList: [],
      hasMore: false,
      MARKS: ['NEW', 'TIME', 'PRIVI'],
      goodsDefaultImg: {
        COURSE: 'https://image.xiaomaiketang.com/xm/internal/eMdhFaJ3NF.png',
        GOODS: 'https://image.xiaomaiketang.com/xm/internal/BebQYQSnHz.png',
        FEE_ITEM: 'https://image.xiaomaiketang.com/xm/internal/BGDFZxjSzk.png',
        SUITE: 'https://image.xiaomaiketang.com/xm/internal/3XhA6MQnSG.png',
      },
    };
  },
  methods: {
    onRefresh(done) {
      this.fetchHotSellCommodityList(done);
    },
    onInfinite(done) {
      this.fetchHotSellCommodityList(done);
    },
    // 获取推荐商品列表
    fetchHotSellCommodityList(done) {
      const params = {
        instId: this.$route.query.instId,
      };
      axios.Customer('anon/mall/fetchHotSellCommodityList', params).then(res => {
        console.log('推荐商品列表', res.result);
        this.hasMore = false;
        this.hotSellList = res.result;
        done && done();
      });
    },
    sortCoursePrice(theArr) {
      let theSmallPrice = theArr[0].totalPrice;
      for (var i = 0; i < theArr.length; i++) {
        if (theSmallPrice > theArr[i].totalPrice) {
          theSmallPrice = theArr[i].totalPrice;
        }
      }
      return theSmallPrice;
    },
    sortUnderlinePrice(theArr) {
      let theSmallUnderlinePrice = 0;
      for (let i = 0; i < theArr.length; i++) {
        if (theArr[i].underlinePrice && theArr[i].underlinePrice !== 0) {
          theSmallUnderlinePrice = theArr[i].underlinePrice;
          break;
        }
      }
      for (let j = 0; j < theArr.length; j++) {
        if (theSmallUnderlinePrice > theArr[j].underlinePrice && theArr[j].underlinePrice !== 0) {
          theSmallUnderlinePrice = theArr[j].underlinePrice;
        }
      }
      return theSmallUnderlinePrice;
    },
    toProDetail(commodityId) {
      window.router.push({
        name: 'online_product_detail',
        query: {
          instId: this.$route.query.instId,
          instName: this.$route.query.instName,
          commodityId,
        },
      });
    },
    doShare() {
      const name =  this.$route.query.instName && this.$route.query.instName !== '在线商城' ? this.$route.query.instName:'' ;
      WechatApi.doWapShare({
        title: `${name}在线商城全面上线，优质商品等您选购`,
        desc: '点击进入商城推荐页，了解更多',
        linkUrl:
          location.origin +
          location.pathname +
          '#/online/recommend?instId=' +
          this.$route.query.instId +
          '&instName=' +
          window.encodeURIComponent(this.$route.query.instName) +
          '&appId=' +
          (this.$route.query.appId || User.appId()) ,
        imgUrl:  this.$route.query.banner || 'https://image.xiaomaiketang.com/xm/N4AQhzkkPR.png',
      });
      wx.miniProgram.postMessage({
        data: {
          title: `${name}在线商城全面上线，优质商品等您选购`,
          desc: '点击进入商城推荐页，了解更多',
          linkUrl:
            location.origin +
            location.pathname +
            '#/online/recommend?instId=' +
            this.$route.query.instId +
            '&instName=' +
            window.encodeURIComponent(this.$route.query.instName) +
            '&appId=' +
            (this.$route.query.appId || User.appId()) ,
          imgUrl:  this.$route.query.banner || 'https://image.xiaomaiketang.com/xm/N4AQhzkkPR.png',
        },
      });
    },
  },
};
</script>

<style lang="less">
.recommend-page {
  .product {
    margin-top: 0.24rem;
    li {
      display: flex;
      margin: 0 0.32rem 0.2rem 0.32rem;
      align-items: center;
      overflow: hidden;
      .avatar {
        position: relative;
        overflow: hidden;
        width: 2rem;
        > img {
          display: block;
          height: 2rem;
          width: 2rem;
          border-radius: 0.1rem 0 0 0.1rem;
        }
      }
      .corner-mark {
        position: absolute;
        top: -0.01rem;
        right: -0.01rem;
        display: inline-block;
        min-width: 0.78rem;
        height: 0.32rem;

        &.NEW {
          background: url('https://image.xiaomaiketang.com/xm/internal/WSnp5PDW2D.png') no-repeat center;
          background-size: 42px 20px;
        }
        &.TIME {
          background: url('https://image.xiaomaiketang.com/xm/internal/TJWkdia7wH.png') no-repeat center;
          background-size: 42px 20px;
        }
        &.PRIVI {
          background: url('https://image.xiaomaiketang.com/xm/internal/iaS4shyHSJ.png') no-repeat center;
          background-size: 42px 20px;
        }

        &.customer {
          box-sizing: border-box;
          height: 20px;
          padding: 0 8px;
          color: #fff;
          font-size: 11px;
          line-height: 20px;
          vertical-align: top;
          background: linear-gradient(90deg, #ff8625 0%, #f24f67 100%);
          background-color: #ccc;
          border-radius: 2px;
        }
      }
      .desc {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: #fff;
        padding: 0 0.24rem;
        height: 2rem;
        border-radius: 0 0.1rem 0.1rem 0;
        .name {
          margin-top: 0.16rem;
          color: #4a4a4a;
          font-size: 0.26rem;
          line-height: 0.36rem;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .tag {
          .item {
            padding: 0 0.08rem;
            font-size: 0.22rem;
            line-height: 0.32rem;
            color: #ff6934;
            border: 0.5px solid #ff6934;
          }
        }
        .footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.16rem;
          .price-con {
            .origin-price {
              font-size: 0.36rem;
              color: #ff6934;
              line-height: 0.5rem;
              font-weight: 500;
            }
            .text {
              font-size: 0.22rem;
              font-weight: 400;
              color: #ff6934;
              line-height: 0.36rem;
            }
            .line-price {
              font-size: 0.22rem;
              color: #999999;
              line-height: 0.32rem;
              text-decoration: line-through;
            }
          }
          .buy-btn {
            padding: 0;
            font-size: 0.22rem;
            line-height: 0.52rem;
            font-weight: 400;
            color: #ffffff;
            background: linear-gradient(90deg, #fe8022 0%, #ff6a30 100%);
            border-radius: 0.3rem;
            width: 1.28rem;
            height: 0.52rem;
          }
        }
      }
    }

    .bottom-tip {
      color: #999;
    }
  }
  .down-con {
    .down-img {
      width: 2.24rem;
      height: 1.54rem;
      display: inline-block;
    }
    .tip {
      font-size: 0.26rem;
      color: rgba(153, 153, 153, 1);
      line-height: 0.36rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/mall/Recommend.vue